import { render, staticRenderFns } from "./options-selectior.vue?vue&type=template&id=51a70881"
import script from "./options-selectior.vue?vue&type=script&lang=js"
export * from "./options-selectior.vue?vue&type=script&lang=js"
import style0 from "./options-selectior.vue?vue&type=style&index=0&id=51a70881&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51a70881')) {
      api.createRecord('51a70881', component.options)
    } else {
      api.reload('51a70881', component.options)
    }
    module.hot.accept("./options-selectior.vue?vue&type=template&id=51a70881", function () {
      api.rerender('51a70881', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/selector/options-selectior.vue"
export default component.exports